import { configureStore } from "@reduxjs/toolkit";
import { authSlice } from "./slices/authSlice";
import { authApi } from "./api/authAPI";
import { clinicApi } from "./api/clinicAPI";

const store = configureStore({
    reducer: {
        [authApi.reducerPath]: authApi.reducer, // [userApi.reducerPath] is the same as [userApi.name]: userApi.reducer
        [clinicApi.reducerPath]: clinicApi.reducer,
        auth: authSlice.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(authApi.middleware, clinicApi.middleware),

});

export default store;